export default (theme) => ({
  settingsDetails: {
    overflow: 'hidden',
    boxSizing: 'border-box',
    width: 'calc(100% - 560px)',
    height: '100%',
    backgroundColor: '#ffffff',
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    borderRadius: 33,
    [theme.breakpoints.down('xl')]: {
      width: 'calc(100% - 440px)',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  header: {
    position: 'relative',
    padding: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.disabled.main}`,
  },
  backButton: {
    position: 'absolute',
    top: 10,
    left: 15,
    padding: 15,
    background: 'none',
    border: 'none',
    [theme.breakpoints.down('md')]: {
      padding: '15px 0',
    },
  },
  title: {
    fontSize: 24,
    margin: 'auto',
    textAlign: 'center',
    padding: '0 10px',
    width: '70%',
  },
});
